export default __webpack_public_path__ + "assets/eazy-aszf-2024-en.0362df18.pdf";